module.exports = __webpack_public_path__ + "static/img/publish-pop-title.58d6f72c.png";